import { createSlice } from '@reduxjs/toolkit';
import { agreementsApi } from '@store/rtk/agreements';
import { TableData } from '@uikit/Tables/types';
import { beautifyDateTime } from '@src/utils';
import InfoContent from '@uikit/Info/InfoContent/InfoContent';
import { InfoData } from '@utils/InfoData';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type AgreementsSliceType = {
  contractsAgreementsData: TableData;
  factoringAgreementData: TableData;
};

const { contractsAgreementsColumns, factoringAgreementColumns } = TABLE_COLUMNS;

const initialState: AgreementsSliceType = {
  contractsAgreementsData: {
    columns: contractsAgreementsColumns,
    rows: [],
    size: 5,
  },
  factoringAgreementData: {
    columns: factoringAgreementColumns,
    rows: [],
    size: 5,
  },
};

export const agreementsSlice = createSlice({
  name: 'agreements',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      agreementsApi.endpoints.getContractAgreements.matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          state.contractsAgreementsData = {
            ...state.contractsAgreementsData,
            rows: [
              ...payload.content.map((el, idx) => ({
                ...el,
                id: el.id ? el.id : idx,
                effectiveDate: beautifyDateTime(el?.effectiveDate),
                executionDate: beautifyDateTime(el?.executionDate),
                expirationDate: beautifyDateTime(el?.expirationDate),
              })),
            ],
            ...payload,
            requestTablePageChange:
              agreementsApi.endpoints.getContractAgreements,
            filter: payload.filter || {},
            // filterButtons:payload.filter ,
            tableInfo: {
              toggle: true,
              desc: (
                <InfoContent
                  contentData={InfoData['contactsAgreementsTable']}
                />
              ),
            },
          };
        } else {
          state.contractsAgreementsData.rows = payload;
        }
      }
    );

    builder.addMatcher(
      agreementsApi.endpoints.getFactoringAgreement.matchFulfilled,
      (state, { payload }) => {
        if (payload.content && Array.isArray(payload.content)) {
          state.factoringAgreementData = {
            ...state.factoringAgreementData,
            rows: [
              ...payload.content.map((el, idx) => ({
                ...el,
                id: el.id ? el.id : idx,
                effectiveDate: beautifyDateTime(el?.effectiveDate),
                executionDate: beautifyDateTime(el?.executionDate),
                expirationDate: beautifyDateTime(el?.expirationDate),
                rate: el?.rate + '%',
              })),
            ],
            ...payload,
            requestTablePageChange:
              agreementsApi.endpoints.getFactoringAgreement,
            tableInfo: {
              toggle: true,
              desc: (
                <InfoContent
                  contentData={InfoData['factoringAgreementTable']}
                />
              ),
            },
            filter: payload.filter || {},
          };
        } else {
          state.factoringAgreementData.rows = payload;
        }
      }
    );
  },
});

export const {} = agreementsSlice.actions;
export const selectAgreements = (state: { agreements: AgreementsSliceType }) =>
  state.agreements;
export const agreementsReducer = agreementsSlice.reducer;
